import IztFloatingBubble from './src/izt-floating-bubble'

IztFloatingBubble.install = Vue => {
  Vue.component(IztFloatingBubble.name, IztFloatingBubble)
}

export default IztFloatingBubble
